export enum KycRequestProcess {
  EKycOnly = 'e-kyc-only',
  InformationRequestOnly = 'information-request-only',
  EKycAndInformationRequest = 'e-kyc-and-information-request',
}

export enum KycRequest {
  CustomRequest = 'CUSTOM_REQUEST',
}
